// extracted by mini-css-extract-plugin
export default {"inputWrapper":"InputLabel_inputWrapper__oE1Lm","passwordIcon":"InputLabel_passwordIcon__v5pd-","error":"InputLabel_error__qpfTl"};